/**
 * Small status/label pill. Dot-leading variant for record status; plain
 * variant for counts and metadata.
 * Spec: assets/handoffs/design_system_export/specs/Badge.json
 *
 * @param {'gray'|'brand'|'success'|'warning'|'error'|'blueLight'=gray} color
 * @param {'sm'|'md'=md} size
 * @param {boolean=false} dot
 * @param {ReactNode=} icon
 */
import React from "react";
import classNames from "classnames";
import styles from "./Badge.module.scss";

const Badge = ({
  color = "gray",
  size = "md",
  dot = false,
  icon = null,
  className,
  children,
  ...rest
}) => {
  return (
    <span
      className={classNames(
        styles.root,
        styles[`root--${color}`],
        styles[`root--${size}`],
        className
      )}
      {...rest}
    >
      {dot && <span className={styles.dot} aria-hidden="true" />}
      {!dot && icon && (
        <span className={styles.icon} aria-hidden="true">
          {icon}
        </span>
      )}
      <span className={styles.label}>{children}</span>
    </span>
  );
};

export default Badge;
